module.exports = __webpack_public_path__ + "img/slide-2.a31f5ac4.png";